<template>
  <q-dialog
    v-model="shown"
  >
    <q-card
      style="width: 400px; min-height: 400px;"
    >
      <q-form
        ref="formRef"
      >
        <q-card-section class="row items-center q-mx-xs">
          <div class="text-h6">
            TMS Export
          </div>
          <q-space />
          <q-btn
            v-close-popup
            icon="close"
            flat
            round
            dense
          />
        </q-card-section>
        <q-card-section>
          <div>
            <q-select
              v-model="selectedTmsType"
              :options="$_.map(TMS_EXPORT_TYPES)"
              option-value="value"
              option-label="name"
              label="TMS Type"
              :rules="[val => !!val || 'A TMS type is required']"
            />
          </div>
          <div
            v-if="selectedTmsType && (selectedTmsType.hasBeginDate || selectedTmsType.hasEndDate)"
            class="q-mt-md"
          >
            <iso-date-input
              v-if="selectedTmsType.hasBeginDate"
              v-model="beginDate"
              emit-string="allow-blank"
              class="col-6"
              label="Showings From"
              bottom-slots
              :rules="[
                val => !!val || 'Date is required',
                () => !beginDate || !endDate || beginDate < endDate || 'End date cannot postdate start date'
              ]"
            />
            <iso-date-input
              v-if="selectedTmsType.hasEndDate"
              v-model="endDate"
              emit-string="allow-blank"
              class="col-6"
              label="Showings To"
              bottom-slots
              :rules="[
                val => !!val || 'Date is required',
                () => !endDate || !beginDate || endDate > beginDate || 'End date cannot predate start date'
              ]"
            />
          </div>
          <q-card-section />
        </q-card-section>
        <q-card-actions

          class="row justify-end q-ma-sm"
        >
          <q-btn
            label="Download"
            color="primary"
            @click="downloadExport()"
          />
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import { Notify } from 'quasar'
import { serverUri } from 'src/config'
import { IsoDate } from 'src/models/model'
import IsoDateInput from 'src/modules/admin/components/IsoDateInput'
import FormValidationMixin from 'src/modules/admin/mixins/FormValidationMixin'

export const TMS_EXPORT_TYPES = {
  COMSCORE: { name: 'Comscore', value: 'comscore_upcoming_showings', hasBeginDate: true, hasEndDate: true },
  ROSETTA: { name: 'Rosetta', value: 'upcoming_showings' },
  SCREEN_WRITER: { name: 'ScreenWriter', value: 'screenwriter_upcoming_showings', hasBeginDate: true, hasEndDate: true },
  TCC: { name: 'TCC', value: 'tcc_upcoming_showings', hasEndDate: true }
}

export default {
  name: 'TmsExportDialog',
  components: {
    IsoDateInput
  },
  mixins: [FormValidationMixin],
  data () {
    return {
      selectedTmsType: null,
      beginDate: null,
      endDate: null,
      shown: false
    }
  },
  created () {
    _.extend(this, { IsoDate, TMS_EXPORT_TYPES })
  },
  configuration: ['currentSite'],
  methods: {
    show () {
      this.shown = true
    },
    buildUri () {
      const endpoint = `${serverUri}/tms/${this.selectedTmsType.value}`

      let parameters = `?download=true&site_id=${this.currentSite.id}`

      if (this.selectedTmsType?.hasBeginDate) {
        parameters += `&begin_date=${this.beginDate}`
      }

      if (this.selectedTmsType?.hasEndDate) {
        parameters += `&end_date=${this.endDate}`
      }

      return endpoint + parameters
    },
    downloadExport () {
      this.validateForm(() => {
        window.location.href = this.buildUri()

        Notify.create({
          message: 'Download Started',
          position: 'top',
          type: 'positive'
        })
        this.shown = false
      })
    }
  }
}

</script>
